
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/find",
      function () {
        return require("private-next-pages/find.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/find"])
      });
    }
  